// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2hJU5","additionalInfo":"AgreementModal_additionalInfo__wjIoQ"};